export const fakeSeatMap = (segments, travelers) => ({
  meta: {
    count: segments.length,
  },
  data: segments.map((segment, i) => {
    const segmentId = segment.id;

    const data = {
      id: segmentId,
      type: 'seatmap',
      departure: segment.departure || {
        iataCode: 'LHR',
        terminal: '2',
        at: '2020-08-05T07:25:00',
      },
      arrival: segment.arrival || {
        iataCode: 'MUC',
        terminal: '2',
        at: '2020-08-05T10:15:00',
      },
      carrierCode: segment.carrierCode || 'FI',
      number: segment.number || '2485',
      aircraft: segment.aircraft || {
        code: '32N',
      },
      class: segment.class || 'K',
      flightOfferId: '1',
      segmentId: segmentId,
      decks:
        i % 2 === 0
          ? [
              {
                deckType: 'MAIN',
                deckConfiguration: {
                  width: 7,
                  length: 24,
                  startSeatRow: 8,
                  endSeatRow: 32,
                  startWingsX: 1,
                  endWingsX: 7,
                  startWingsRow: 9,
                  endWingsRow: 18,
                  exitRowsX: [3, 4],
                },
                facilities: [
                  {
                    code: 'G',
                    column: 'A',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                      y: 0,
                    },
                  },
                  {
                    code: 'G',
                    column: 'B',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                      y: 1,
                    },
                  },
                  {
                    code: 'LA',
                    column: 'F',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                      y: 6,
                    },
                  },
                  {
                    code: 'LA',
                    column: 'E',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                      y: 5,
                    },
                  },
                  {
                    code: 'G',
                    column: 'C',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                      y: 2,
                    },
                  },
                  {
                    code: 'G',
                    column: 'D',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                      y: 4,
                    },
                  },
                  {
                    code: 'G',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 23,
                    },
                  },
                ],
                seats: [
                  {
                    cabin: 'M',
                    number: '8A',
                    characteristicsCodes: ['CH', 'LS', 'O', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 0,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '8B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'O'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 0,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '8C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'O'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 0,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '8D',
                    characteristicsCodes: ['A', 'CH', 'O', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 0,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '8E',
                    characteristicsCodes: ['9', 'CH', 'O', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 0,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '8F',
                    characteristicsCodes: ['CH', 'O', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 0,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '9A',
                    characteristicsCodes: ['CH', 'LS', 'O', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '9B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'O', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '9C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'O', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '9D',
                    characteristicsCodes: ['A', 'CH', 'O', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '9E',
                    characteristicsCodes: ['9', 'CH', 'O', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '9F',
                    characteristicsCodes: ['CH', 'O', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '10A',
                    characteristicsCodes: ['1A', '1D', 'CH', 'LS', 'O', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '10B',
                    characteristicsCodes: ['1A', '1D', '9', 'CH', 'LS', 'O', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '10C',
                    characteristicsCodes: ['1A', '1D', 'A', 'CH', 'LS', 'O', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '10D',
                    characteristicsCodes: ['1A', '1D', 'A', 'CH', 'O', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '10E',
                    characteristicsCodes: ['1A', '1D', '9', 'CH', 'O', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '10F',
                    characteristicsCodes: ['1A', '1D', 'CH', 'O', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '11A',
                    characteristicsCodes: ['1A', '1D', 'CH', 'E', 'IE', 'L', 'LS', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '32.00',
                          base: '32.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '11B',
                    characteristicsCodes: ['1A', '1D', '9', 'CH', 'E', 'IE', 'L', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '32.00',
                          base: '32.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '11C',
                    characteristicsCodes: ['1A', '1D', 'A', 'CH', 'E', 'IE', 'L', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '32.00',
                          base: '32.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '11D',
                    characteristicsCodes: ['1A', '1D', 'A', 'CH', 'E', 'IE', 'L', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '32.00',
                          base: '32.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '11E',
                    characteristicsCodes: ['1A', '1D', '9', 'CH', 'E', 'IE', 'L', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '32.00',
                          base: '32.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '11F',
                    characteristicsCodes: ['1A', '1D', 'CH', 'E', 'IE', 'L', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '32.00',
                          base: '32.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '12A',
                    characteristicsCodes: ['1A', 'CH', 'E', 'IE', 'LS', 'O', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '12B',
                    characteristicsCodes: ['1A', '9', 'CH', 'E', 'IE', 'LS', 'O', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '12C',
                    characteristicsCodes: ['1A', 'A', 'CH', 'E', 'IE', 'LS', 'O', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '12D',
                    characteristicsCodes: ['1A', 'A', 'CH', 'E', 'IE', 'O', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '12E',
                    characteristicsCodes: ['1A', '9', 'CH', 'E', 'IE', 'O', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '12F',
                    characteristicsCodes: ['1A', 'CH', 'E', 'IE', 'O', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '24.00',
                          base: '24.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '14A',
                    characteristicsCodes: ['1A', 'CH', 'LS', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '14B',
                    characteristicsCodes: ['1A', '9', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '14C',
                    characteristicsCodes: ['1A', 'A', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '14D',
                    characteristicsCodes: ['1A', 'A', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '14E',
                    characteristicsCodes: ['1A', '9', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '14F',
                    characteristicsCodes: ['1A', 'CH', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '15A',
                    characteristicsCodes: ['CH', 'LS', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '15B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '15C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '15D',
                    characteristicsCodes: ['A', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '15E',
                    characteristicsCodes: ['9', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '15F',
                    characteristicsCodes: ['CH', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '16A',
                    characteristicsCodes: ['CH', 'LS', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '16B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '16C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '16D',
                    characteristicsCodes: ['A', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'OCCUPIED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '16E',
                    characteristicsCodes: ['9', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '16F',
                    characteristicsCodes: ['CH', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '18A',
                    characteristicsCodes: ['CH', 'LS', 'OW', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '18B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '18C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'OW'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '18D',
                    characteristicsCodes: ['A', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '18E',
                    characteristicsCodes: ['9', 'CH', 'OW', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '18F',
                    characteristicsCodes: ['CH', 'OW', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '19A',
                    characteristicsCodes: ['1A', 'CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '19B',
                    characteristicsCodes: ['1A', '9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '19C',
                    characteristicsCodes: ['1A', 'A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '19D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '19E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '19F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '20A',
                    characteristicsCodes: ['CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '20B',
                    characteristicsCodes: ['9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '20C',
                    characteristicsCodes: ['A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '20D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '20E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '20F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '21A',
                    characteristicsCodes: ['CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '21B',
                    characteristicsCodes: ['9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '21C',
                    characteristicsCodes: ['A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '21D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '21E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '21F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '22A',
                    characteristicsCodes: ['CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '22B',
                    characteristicsCodes: ['9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '22C',
                    characteristicsCodes: ['A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '22D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '22E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '22F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '23A',
                    characteristicsCodes: ['CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '23B',
                    characteristicsCodes: ['9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '23C',
                    characteristicsCodes: ['A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '23D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '23E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '23F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '24A',
                    characteristicsCodes: ['1A', 'CH', 'LS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '24B',
                    characteristicsCodes: ['1A', '9', 'CH', 'LS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '24C',
                    characteristicsCodes: ['1A', 'A', 'CH', 'LS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '24D',
                    characteristicsCodes: ['A', 'CH', 'RS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '24E',
                    characteristicsCodes: ['9', 'CH', 'RS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '24F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '25A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '25B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '25C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '25D',
                    characteristicsCodes: ['A', 'CH', 'RS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '25E',
                    characteristicsCodes: ['9', 'CH', 'RS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '25F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '26A',
                    characteristicsCodes: ['CH', 'H', 'LS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '26B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '26C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '26D',
                    characteristicsCodes: ['A', 'CH', 'RS', 'U', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '26E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '26F',
                    characteristicsCodes: ['CH', 'H', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '27A',
                    characteristicsCodes: ['CH', 'H', 'LS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '27B',
                    characteristicsCodes: ['9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '27C',
                    characteristicsCodes: ['A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '27D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '27E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '27F',
                    characteristicsCodes: ['CH', 'H', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '28A',
                    characteristicsCodes: ['CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '28B',
                    characteristicsCodes: ['9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '28C',
                    characteristicsCodes: ['A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '28D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '28E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '28F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '29A',
                    characteristicsCodes: ['1A', 'CH', 'LS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '29B',
                    characteristicsCodes: ['1A', '9', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '29C',
                    characteristicsCodes: ['1A', 'A', 'CH', 'LS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '29D',
                    characteristicsCodes: ['A', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '29E',
                    characteristicsCodes: ['9', 'CH', 'RS'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '29F',
                    characteristicsCodes: ['CH', 'RS', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '30A',
                    characteristicsCodes: ['CH', 'LS', 'V', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '30B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '30C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '30D',
                    characteristicsCodes: ['A', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '30E',
                    characteristicsCodes: ['9', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '30F',
                    characteristicsCodes: ['CH', 'RS', 'V', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '31A',
                    characteristicsCodes: ['CH', 'LS', 'V', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '31B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '31C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '31D',
                    characteristicsCodes: ['A', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '31E',
                    characteristicsCodes: ['9', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '31F',
                    characteristicsCodes: ['CH', 'RS', 'V', 'W'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '32A',
                    characteristicsCodes: ['1W', '6A', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '32B',
                    characteristicsCodes: ['6A', '9', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '32C',
                    characteristicsCodes: ['6A', 'A', 'CH', 'LS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '32D',
                    characteristicsCodes: ['6A', 'A', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '32E',
                    characteristicsCodes: ['6A', '9', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'M',
                    number: '32F',
                    characteristicsCodes: ['1W', '6A', 'CH', 'RS', 'V'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '17.00',
                          base: '17.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 6,
                    },
                  },
                ],
              },
            ]
          : [
              {
                deckType: 'MAIN',
                deckConfiguration: {
                  width: 7,
                  length: 33,
                  startSeatRow: 1,
                  endSeatRow: 32,
                  startWingsRow: 9,
                  endWingsRow: 18,
                  exitRowsX: [12, 13],
                },
                facilities: [
                  {
                    code: 'LA',
                    column: 'A',
                    position: 'FRONT',
                    coordinates: {
                      x: 0,
                      y: 0,
                    },
                  },
                  {
                    code: 'G',
                    column: 'F',
                    position: 'FRONT',
                    coordinates: {
                      x: 0,
                      y: 6,
                    },
                  },
                  {
                    code: 'G',
                    column: 'E',
                    position: 'FRONT',
                    coordinates: {
                      x: 0,
                      y: 5,
                    },
                  },
                  {
                    code: 'G',
                    column: 'D',
                    position: 'FRONT',
                    coordinates: {
                      x: 0,
                      y: 4,
                    },
                  },
                  {
                    code: 'CL',
                    column: 'A',
                    row: '1',
                    position: 'SEAT',
                    coordinates: {
                      x: 1,
                      y: 0,
                    },
                  },
                  {
                    code: 'CL',
                    column: 'B',
                    row: '1',
                    position: 'SEAT',
                    coordinates: {
                      x: 1,
                      y: 1,
                    },
                  },
                  {
                    code: 'SO',
                    column: 'E',
                    row: '32',
                    position: 'SEAT',
                    coordinates: {
                      x: 31,
                      y: 5,
                    },
                  },
                  {
                    code: 'SO',
                    column: 'F',
                    row: '32',
                    position: 'SEAT',
                    coordinates: {
                      x: 31,
                      y: 6,
                    },
                  },
                  {
                    code: 'LA',
                    column: 'A',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 32,
                      y: 0,
                    },
                  },
                  {
                    code: 'G',
                    column: 'F',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 32,
                      y: 6,
                    },
                  },
                  {
                    code: 'G',
                    column: 'E',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 32,
                      y: 5,
                    },
                  },
                  {
                    code: 'G',
                    column: 'D',
                    row: '32',
                    position: 'REAR',
                    coordinates: {
                      x: 32,
                      y: 4,
                    },
                  },
                ],
                seats: [
                  {
                    cabin: 'ECONOMY',
                    number: '1D',
                    characteristicsCodes: ['1B', 'A', 'FC', 'K', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '1E',
                    characteristicsCodes: ['1B', '9', 'FC', 'K', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '1F',
                    characteristicsCodes: ['1B', 'FC', 'K', 'O', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 1,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '2A',
                    characteristicsCodes: ['1B', 'FC', 'K', 'LS', 'O', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '2B',
                    characteristicsCodes: ['1B', '9', 'FC', 'K', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '2C',
                    characteristicsCodes: ['1B', 'A', 'FC', 'K', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '2D',
                    characteristicsCodes: ['A', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '2E',
                    characteristicsCodes: ['9', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '2F',
                    characteristicsCodes: ['FC', 'O', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 2,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '3A',
                    characteristicsCodes: ['FC', 'LS', 'O', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '3B',
                    characteristicsCodes: ['9', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '3C',
                    characteristicsCodes: ['A', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '3D',
                    characteristicsCodes: ['A', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '3E',
                    characteristicsCodes: ['9', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '3F',
                    characteristicsCodes: ['FC', 'O', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 3,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '4A',
                    characteristicsCodes: ['FC', 'LS', 'O', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '4B',
                    characteristicsCodes: ['9', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '4C',
                    characteristicsCodes: ['A', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '4D',
                    characteristicsCodes: ['A', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '4E',
                    characteristicsCodes: ['9', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '4F',
                    characteristicsCodes: ['FC', 'O', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 4,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '5A',
                    characteristicsCodes: ['FC', 'LS', 'O', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '5B',
                    characteristicsCodes: ['9', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '5C',
                    characteristicsCodes: ['A', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '5D',
                    characteristicsCodes: ['A', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '5E',
                    characteristicsCodes: ['9', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '5F',
                    characteristicsCodes: ['FC', 'O', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 5,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '6A',
                    characteristicsCodes: ['FC', 'LS', 'O', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '6B',
                    characteristicsCodes: ['9', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '6C',
                    characteristicsCodes: ['A', 'FC', 'LS', 'O', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '6D',
                    characteristicsCodes: ['A', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '6E',
                    characteristicsCodes: ['9', 'FC', 'O', 'RS', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '6F',
                    characteristicsCodes: ['FC', 'O', 'RS', 'W', '1'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                      },
                    ],
                    coordinates: {
                      x: 6,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '7A',
                    characteristicsCodes: ['CH', 'FC', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '7B',
                    characteristicsCodes: ['9', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '7C',
                    characteristicsCodes: ['A', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '7D',
                    characteristicsCodes: ['A', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '7E',
                    characteristicsCodes: ['9', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '7F',
                    characteristicsCodes: ['CH', 'FC', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 7,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '8A',
                    characteristicsCodes: ['CH', 'FC', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '8B',
                    characteristicsCodes: ['9', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '8C',
                    characteristicsCodes: ['A', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '8D',
                    characteristicsCodes: ['A', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '8E',
                    characteristicsCodes: ['9', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '8F',
                    characteristicsCodes: ['CH', 'FC', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 8,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '9A',
                    characteristicsCodes: ['CH', 'FC', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '9B',
                    characteristicsCodes: ['9', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '9C',
                    characteristicsCodes: ['A', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '9D',
                    characteristicsCodes: ['A', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '9E',
                    characteristicsCodes: ['9', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '9F',
                    characteristicsCodes: ['CH', 'FC', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 9,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '10A',
                    characteristicsCodes: ['CH', 'FC', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '10B',
                    characteristicsCodes: ['9', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '10C',
                    characteristicsCodes: ['A', 'CH', 'FC', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '10D',
                    characteristicsCodes: ['A', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '10E',
                    characteristicsCodes: ['9', 'CH', 'FC', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '10F',
                    characteristicsCodes: ['CH', 'FC', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 10,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '11A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '11B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '11C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '11D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '11E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '11F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 11,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '12A',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'LS',
                      'W',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '12B',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      '9',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'LS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '12C',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'A',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'LS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '12D',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'A',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'RS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '12E',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      '9',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'RS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '12F',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'RS',
                      'W',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 12,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '14A',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'LS',
                      'W',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '14B',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      '9',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'LS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '14C',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'A',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'LS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '14D',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'A',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'RS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '14E',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      '9',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'RS',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '14F',
                    characteristicsCodes: [
                      '1A',
                      '1B',
                      'CH',
                      'E',
                      'IE',
                      'L',
                      'RS',
                      'W',
                      '1A_AQC_PREMIUM_SEAT',
                    ],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '15.00',
                          base: '15.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 13,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '15A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '15B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '15C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '15D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '15E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '15F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 14,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '16A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '16B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '16C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '16D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '16E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '16F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 15,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '17A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '17B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '17C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '17D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '17E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '17F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 16,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '18A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '18B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '18C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '18D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '18E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '18F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 17,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '19A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '19B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '19C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '19D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '19E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '19F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 18,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '20A',
                    characteristicsCodes: ['C', 'CH', 'LS', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '20B',
                    characteristicsCodes: ['9', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '20C',
                    characteristicsCodes: ['A', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '20D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '20E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '20F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 19,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '21A',
                    characteristicsCodes: ['C', 'CH', 'LS', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '21B',
                    characteristicsCodes: ['9', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '21C',
                    characteristicsCodes: ['A', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '21D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '21E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '21F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 20,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '22A',
                    characteristicsCodes: ['C', 'CH', 'LS', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '22B',
                    characteristicsCodes: ['9', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '22C',
                    characteristicsCodes: ['A', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '22D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '22E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '22F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 21,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '23A',
                    characteristicsCodes: ['C', 'CH', 'LS', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '23B',
                    characteristicsCodes: ['9', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '23C',
                    characteristicsCodes: ['A', 'C', 'CH', 'LS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '23D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '23E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '23F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 22,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '24A',
                    characteristicsCodes: ['CH', 'LS', 'U', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 23,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '24B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 23,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '24C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 23,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '24D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 23,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '24E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 23,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '24F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 23,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '25A',
                    characteristicsCodes: ['CH', 'LS', 'U', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 24,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '25B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 24,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '25C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 24,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '25D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 24,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '25E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 24,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '25F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 24,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '26A',
                    characteristicsCodes: ['CH', 'LS', 'U', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 25,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '26B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 25,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '26C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 25,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '26D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 25,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '26E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 25,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '26F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 25,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '27A',
                    characteristicsCodes: ['CH', 'LS', 'U', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 26,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '27B',
                    characteristicsCodes: ['9', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 26,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '27C',
                    characteristicsCodes: ['A', 'CH', 'LS', 'U', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 26,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '27D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 26,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '27E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 26,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '27F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 26,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '28A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 27,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '28B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 27,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '28C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 27,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '28D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 27,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '28E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 27,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '28F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 27,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '29A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 28,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '29B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 28,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '29C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 28,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '29D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 28,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '29E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 28,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '29F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 28,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '30A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 29,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '30B',
                    characteristicsCodes: ['9', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 29,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '30C',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 29,
                      y: 2,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '30D',
                    characteristicsCodes: ['A', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 29,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '30E',
                    characteristicsCodes: ['9', 'CH', 'RS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 29,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '30F',
                    characteristicsCodes: ['CH', 'RS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 29,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '31A',
                    characteristicsCodes: ['CH', 'LS', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 30,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '31B',
                    characteristicsCodes: ['A', 'CH', 'LS', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'AVAILABLE',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 30,
                      y: 1,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '31D',
                    characteristicsCodes: ['A', 'CH', 'DE', 'RS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 30,
                      y: 4,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '31E',
                    characteristicsCodes: ['9', 'CH', 'DE', 'RS', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 30,
                      y: 5,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '31F',
                    characteristicsCodes: ['CH', 'DE', 'RS', 'W', '1', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 30,
                      y: 6,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '32A',
                    characteristicsCodes: ['1D', 'CH', 'LS', 'V', 'W', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 31,
                      y: 0,
                    },
                  },
                  {
                    cabin: 'ECONOMY',
                    number: '32B',
                    characteristicsCodes: ['1D', 'A', 'CH', 'LS', 'V', '1A_AQC_PREMIUM_SEAT'],
                    travelerPricing: [
                      {
                        travelerId: '1',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                      {
                        travelerId: '2',
                        seatAvailabilityStatus: 'BLOCKED',
                        price: {
                          currency: 'EUR',
                          total: '11.00',
                          base: '11.00',
                          taxes: [
                            {
                              amount: '0.00',
                              code: 'SUPPLIER',
                            },
                          ],
                        },
                      },
                    ],
                    coordinates: {
                      x: 31,
                      y: 1,
                    },
                  },
                ],
              },
            ],
      availableSeatsCounters: travelers.map((t) => ({
        travelerId: t,
        value: 116,
      })),
    };

    if (i % 2 !== 0) {
      data['aircraftCabinAmenities'] = {
        power: {
          isChargeable: false,
          powerType: 'USB_PORT',
          usbType: 'USB_C',
        },
        seat: {
          legSpace: 29,
          spaceUnit: 'INCHES',
          tilt: 'NORMAL',
          medias: [
            {
              title: 'Comfortable Seats',
              href: 'https://pdt.content.amadeus.com/AncillaryServicesMedia/14223418_395.jpg',
              description: {
                text: 'Settle in with comfortable seats and an ecoTHREAD blanket made from 100% recycled plastic bottles.',
                lang: 'EN',
              },
              mediaType: 'image',
            },
            {
              title: 'Stay Connected',
              href: 'https://pdt.content.amadeus.com/AncillaryServicesMedia/71344149_DFL.jpg',
              description: {
                text: 'Stay connected next time you fly. Choose from our great value Wi-Fi plans.',
                lang: 'EN',
              },
              mediaType: 'image',
            },
            {
              title: 'Be Curious',
              href: 'https://pdt.content.amadeus.com/AncillaryServicesMedia/42266150_401.jpg',
              description: {
                text: "With special seat,meals, toys, and dedicated children's ice channels, we encourage curious minds and inspire tomorrow's explorers.",
                lang: 'EN',
              },
              mediaType: 'image',
            },
          ],
        },
        wifi: {
          isChargeable: true,
          wifiCoverage: 'FULL',
        },
        entertainment: [
          {
            isChargeable: false,
            entertainmentType: 'AUDIO_VIDEO_ON_DEMAND',
          },
          {
            isChargeable: false,
            entertainmentType: 'IP_TV',
          },
        ],
        food: {
          isChargeable: false,
          foodType: 'SNACK',
        },
        beverage: {
          isChargeable: false,
          beverageType: 'ALCOHOLIC_AND_NON_ALCOHOLIC',
        },
      };
    }
    return data;
  }),
  dictionaries: {
    locations: {
      LHR: {
        cityCode: 'LON',
        countryCode: 'GB',
      },
      MUC: {
        cityCode: 'MUC',
        countryCode: 'DE',
      },
      NCE: {
        cityCode: 'NCE',
        countryCode: 'FR',
      },
      ORY: {
        cityCode: 'PAR',
        countryCode: 'FR',
      },
    },
    facilities: {
      LA: 'Lavatory',
      G: 'Galley',
      CL: 'Closet',
      SO: 'Storage Space',
    },
    seatCharacteristics: {
      1: 'Restricted seat - General',
      9: 'Center seat (not window, not aisle)',
      A: 'Aisle seat',
      RS: 'Right side of aircraft',
      DE: 'Deportee',
      C: 'Crew seat',
      CH: 'Chargeable seats',
      E: 'Exit row seat',
      LS: 'Left side of aircraft',
      K: 'Bulkhead seat',
      L: 'Leg space seat',
      '1A_AQC_PREMIUM_SEAT': 'Premium seat',
      O: 'Preferential seat',
      '1A': 'Seat not allowed for infant',
      '1B': 'Seat not allowed for medical',
      '1D': 'Restricted recline seat',
      U: 'Seat suitable for unaccompanied minors',
      V: 'Seat to be left vacant or offered last',
      W: 'Window seat',
      IE: 'Seat not suitable for child',
      FC: 'Front of cabin class/compartment',
      '1W': 'Window seat without window',
      H: 'Seat with facilities for handicapped/incapacitated passenger',
      OW: 'Overwing seat(s)',
      '6A': 'In front of galley seat',
    },
  },
});

const fakeNames = {
  MALE: ['Andrea', 'Carlo', 'Davide', 'Edoardo', 'Giovanni', 'Luca', 'Luigi', 'Mario', 'Michele'],
  FEMALE: ['Anna', 'Carla', 'Daniela', 'Elena', 'Giovanna', 'Lucia', 'Luisa', 'Maria', 'Michela'],
};

const getFakeName = (gender, alreadyUsed = []) => {
  const names = (fakeNames[gender] || fakeNames['MALE']).filter(
    (name) => !alreadyUsed.includes(name)
  );
  return names[Math.floor(Math.random() * names.length)];
};

export const fakePassenger = (
  travelerIndex,
  namesToAvoid = [],
  withMiddleName = false,
  withSecondLastName = false
) => {
  const gender = travelerIndex % 2 === 0 ? 'MALE' : 'FEMALE';
  const firstname = getFakeName(gender, namesToAvoid);
  const middlename = withMiddleName ? getFakeName(gender, [...namesToAvoid, firstname]) : '';

  return {
    firstname,
    middlename,
    lastname: 'Rossi',
    second_lastname: withSecondLastName ? 'Verdi' : '',
    gender,
  };
};
